import { ChevronLeft24Filled } from '@fluentui/react-icons';
import { SkillsTopContainer } from '../../SkillsAddPopup/styles/SkillsAddPopup.styled';
import { AddSkillsBackButtonContainer } from '../styles/common.styled';

interface SkillTopContainerMobileProps {
  onClose: () => void;
  onClear: () => void;
  title: string;
  displayCondition: boolean;
}

export const SkillTopContainerMobile = ({
  onClose,
  onClear,
  title,
  displayCondition,
}: SkillTopContainerMobileProps) => {
  return (
    <SkillsTopContainer displayCondition={displayCondition}>
      <AddSkillsBackButtonContainer onClick={onClose}>
        <ChevronLeft24Filled />
      </AddSkillsBackButtonContainer>
      <h1>{title}</h1>
      <span onClick={onClear}>Clear all</span>
    </SkillsTopContainer>
  );
};
